<div class="summary-container" *ngIf="!state">
  <div class="summary-wrapper">
    <div *ngIf="!state" class="trip-summary">
      <button class="summary-button green" *ngIf="summaryConfigObj['Total Trips'].visibility.visible">
        <span class="button-text">{{summaryConfigObj['Total Trips'].displayName}}</span>
        <span class="button-value">{{totalNoOfTrips}}</span>
      </button>
      <button class="summary-button red" *ngIf="summaryConfigObj['Vendor Not Assinged Trips'].visibility.visible">
        <span class="button-text">{{summaryConfigObj['Vendor Not Assinged Trips'].displayName}}</span>
        <span class="button-value">{{tripsWithNoVendors}}</span>
      </button>
      <button class="summary-button orange" *ngIf="summaryConfigObj['Cab Not Assigned Trips'].visibility.visible">
        <span class="button-text">{{summaryConfigObj['Cab Not Assigned Trips'].displayName}}</span>
        <span class="button-value">{{tripsWithNoCabs}}</span>
      </button>
      <button class="summary-button pink" *ngIf="summaryConfigObj['Cancelled Trips'].visibility.visible">
        <span class="button-text">{{summaryConfigObj['Cancelled Trips'].displayName}}</span>
        <span class="button-value">{{cancelledTrips}}</span>
      </button>
      <button class="summary-button yellow" *ngIf="summaryConfigObj['MarshallNotAssigned'] && summaryConfigObj['MarshallNotAssigned'].visibility.visible">
        <span class="button-text">{{summaryConfigObj['MarshallNotAssigned'].displayName}}</span>
        <span class="button-value">{{marshallNotAssigned}}</span>
      </button>
      <button class="summary-button red" *ngIf="summaryConfigObj['Multi-Day Trips'] && summaryConfigObj['Multi-Day Trips'].visibility.visible">
        <span class="button-text">{{summaryConfigObj['Multi-Day Trips'].displayName}}</span>
        <span class="button-value">{{multiDayBookings}}</span>
      </button>
      <button class="summary-button light-green" *ngIf="summaryConfigObj['Completed Trips'] && summaryConfigObj['Completed Trips'].visibility.visible">
        <span class="button-text">{{summaryConfigObj['Completed Trips'].displayName}}</span>
        <span class="button-value">{{tripCompleted}}</span>
      </button>
    </div>

    <div *ngIf="!state" class="last-updated-wrapper">
      <div>
        Last updated {{now}} seconds ago
      </div>
    </div>
  </div>
</div>

<div class="search-container">
  <div class="search-filter-container">

    <div class="actions-bar">
      <div class="head-check">
        <app-dropdown xPosition="left" style="padding-right: 20px">
          <div dropdown-trigger class="trigger">
            <div class="checkbox-header-actions">
              <app-checkbox *ngIf="!showCheckboxHyphen" [checked]="allBookingsSelected" checkboxValue="all"
                (checkboxSelectedCallback)="handleAllBookingsSelected($event)"></app-checkbox>
              <app-checkbox *ngIf="showCheckboxHyphen" type="hyphen" [checked]="showCheckboxHyphen" checkboxValue="none"
                (checkboxSelectedCallback)="handleAllBookingsSelected($event)">
              </app-checkbox>
              <span class="checkmark-dropdown">
                <div class="dropdown-down-icon dropdown-down-icon-header"></div>
              </span>
            </div>
          </div>
          <div dropdown-menu class="checkbox-menu">
            <div class="checkbox-menu-item" (click)="handleAllBookingsSelected({checked: true})">All</div>
            <div class="checkbox-menu-item" (click)="selectVendorAssignedBookings()">Vendor Assigned</div>
            <div class="checkbox-menu-item" (click)="selectVendorUnAssignedBookings()">Vendor Unassigned
            </div>
          </div>
        </app-dropdown>

      </div>

      <app-button class="mr-24" type="action-button" text="Assign Vendor"
        [disabled]="!selectedBookings.length && !selectedVendor" (clickCallback)="showModal = !showModal">
      </app-button>

      <app-button class="mr-24" type="action-button" text="Track"
        [disabled]="!selectedBookings.length && !selectedVendor" (clickCallback)="toggleCabTrack()">
      </app-button>

      <app-dropdown *ngIf="bulkActionsConfig.config.visibility.visible" class="dropdown-container">
        <div dropdown-trigger>
          <div style="cursor: pointer;">
            <img src="../../../../assets/images/more-actions_24 (1).svg" alt="">
          </div>
        </div>
        <div dropdown-menu class="actions-menu" *ngIf="selectedBookings.length">
          <div class="accept-reject-wrapper">
            <div *ngIf="bulkbookingActionsConfigObj['Accept'].visibility.visible" class="accept menu-item"
              (click)="handleStatusUpdate({action: 'vendor_status_update', status: 'ACCEPTED'})">
              <img src="assets/images/accept-24.svg" />
              <label class="action-description">{{bulkbookingActionsConfigObj['Accept'].displayName}}</label>
            </div>
            <div *ngIf="bulkbookingActionsConfigObj['Deny'].visibility.visible" class="reject menu-item"
              (click)="handleStatusUpdate({action: 'vendor_status_update', status: 'DENIED'})">
              <img src='assets/cancel-square-filled.svg' />
              <label>{{bulkbookingActionsConfigObj['Deny'].displayName}}</label>
            </div>
          </div>
          <div
            *ngIf="(bulkbookingActionsConfigObj['Approve'].visibility.visible || bulkbookingActionsConfigObj['Reject'].visibility.visible) && (bulkbookingActionsConfigObj['Accept'].visibility.visible || bulkbookingActionsConfigObj['Deny'].visibility.visible)"
            class="border-placeholder">
          </div>
          <div class="approve-deny-wrapper">
            <div *ngIf="bulkbookingActionsConfigObj['Approve'].visibility.visible" class="accept menu-item"
              (click)="handleStatusUpdate({action: 'manager_status_update', status: 'APPROVED'})">
              <img src="assets/images/ic-ui-tick-24.svg" />
              <label>{{bulkbookingActionsConfigObj['Approve'].displayName}}</label>
            </div>
            <div *ngIf="bulkbookingActionsConfigObj['Reject'].visibility.visible" class="reject menu-item"
              (click)="handleStatusUpdate({action: 'manager_status_update', status: 'REJECTED'})">
              <img src='assets/images/actions_cancelled-24.svg' />
              <label>{{bulkbookingActionsConfigObj['Reject'].displayName}}</label>
            </div>
          </div>

          <div class="merge-booking-wrapper" *ngIf="bulkbookingActionsConfigObj['Merge'].visibility.visible">
            <div class="merge-booking menu-item" (click)="showBookingMerge()">
              <img src="assets/images/merge.svg" />
              <label>{{bulkbookingActionsConfigObj['Merge'].displayName}}</label>
            </div>
          </div>

          <!-- uploadRateCard -->
          <div
            *ngIf="bulkbookingActionsConfigObj['uploadRateCard'] && bulkbookingActionsConfigObj['uploadRateCard'].visibility.visible"
            class="merge-booking-wrapper">
            <div class="merge-booking menu-item padding-0-imp">
              <label class="file-upload-input-wrapper item">
                <input #fileUpload type="file" class="file-upload-input" [accept]="accept || '.jpeg, .png, .jpg'"
                  (change)="handleUploadReport($event.target.files)">
                <img src="assets/images/upload-rateCard_24.svg" />
                {{bulkbookingActionsConfigObj['uploadRateCard'].displayName}}
              </label>
            </div>
          </div>

        </div>
        <div dropdown-menu class="actions-menu" *ngIf="!selectedBookings.length">
          <div class="no-bookings-view">Select bookings to see more actions</div>
        </div>
      </app-dropdown>

    </div>

  </div>
  <div class="search-section" *ngIf="!state">
    <div class="search-content">
      <div *ngIf="!state" class="search-wrapper">
        <img style="padding: 4px;" src="../../../../assets/images/search-icon.svg" alt="">
        <input [(ngModel)]="searchInput" (keyup)="handleSearch($event)" id="input-block" type="text"
          placeholder="Search">
      </div>
    </div>



    <app-popover *ngIf="showModal" size="Assign-model" (closeCallback)="closeAssignVendor()">
      <div popover-header>Assign</div>

      <div popover-content class="vendor-dropdown-container"
        *ngIf="vendorSelectConfigObj && vendorSelectConfigObj['VendorAssignment'].visibility.visible">
        <app-vendor-select [vendors]="vendors" [elementType]="vendorSelectConfigObj['VendorAssignment'].elementType"
          [selectedBookings]="selectedBookings" [vendorFormControl]="vendorFormControl"
          (globalVendorSelectedCallback)="onVendorValueSelected($event)" [vendorSelectConfigObj]="vendorSelectConfigObj"
          isGlobal=true>
        </app-vendor-select>

      </div>

      <!-- </div> -->

      <div popover-actions class="submit-button"
        *ngIf="submitButtonConfig && submitButtonConfig.config.visibility.visible">
        <app-button type="plainText" text="Clear" class="mr-20" (clickCallback)="clearUpdate()"></app-button>
        <app-button type="primaryFilled" text="Apply" [disabled]="!selectedBookings.length && !selectedVendor"
          (clickCallback)="handleSubmitVendorUpdate()"></app-button>
      </div>
    </app-popover>

  </div>
</div>





<app-bulkcancelpopover *ngIf="showCancelConfirmDialog" title="Cancel Bookings"
  [eligibleBookingIds]="bookingWithinCancelCutOff" [nonEligibleBookingIds]="bookingWithCutOffPassed"
  [cancelPopupConfig]="cancelPopUpConfig.elementConfigList[0]" (approveCallback)="handleCancelBooking($event)"
  (dismissCallback)="dismissCancelBookingDialog()"></app-bulkcancelpopover>


  <app-popover size="actions-popover" *ngIf="mergeError" (closeCallback)="hideMergeBookingError()">
    <div popover-header class="merge-error">
      <div class="displayFlex">
        <span> <img src="assets/ic-ui-warning-24.svg" alt=""></span>
        <span class="fs-20 font-weight-700 ml-12">Warning </span> 
      </div>
    </div>
    <div popover-content>
      {{mergeError}}
    </div>
    <div popover-actions>
      <app-button type="primaryFilled" text="Okay" (clickCallback)="hideMergeBookingError()"></app-button>
    </div>
  </app-popover>

  <app-dialog *ngIf="mergeVendorError" titleText="Warning" type="confirm" [buttonText]="['Proceed', 'Cancel']"
  (approveCallback)="isMergeVisible=true;mergeVendorError=false" 
  (dismissCallback)="mergeVendorError=false"
  (closeCallback)="mergeVendorError=false" [icon]="true"
  src="assets/ic-ui-warning-24.svg">
          Some of the bookings have vendors already assigned to them. After merging the bookings you will have to reassign the vendor again.
 </app-dialog>

<app-dialog class="cancel-bookings-dialog" *ngIf="downloadReportFailed" titleText="Download failed" type="alert"
  [buttonText]="['Okay']" (approveCallback)="hideDownloadReportError()">
  {{downloadReportFailed}}
</app-dialog>
<app-multiple-cab-track *ngIf="isCabTrackVisible" (closeCallback)="toggleCabTrack()"
  [bookings]="selectedBookingDetailed"></app-multiple-cab-track>
<app-merge-bookings *ngIf="isMergeVisible" (successCallback)="handleMergeSuccess($event)"
  (closeCallback)="hideMergeBooking()" [bookings]="selectedBookingDetailed" [miscelleneousConfig]="miscelleneousConfig" ></app-merge-bookings>
<app-file-upload *ngIf="showFileUploadModal" [fileToUpload]="fileToUpload"
  (submitUploadReportCallback)="submitUploadReport()" (handleDismissUploadFileModal)="handleDismissUploadFileModal()"
  [uploadFileError]="uploadFileError">
</app-file-upload>

<app-loader *ngIf="isLoading"></app-loader>

<app-toast *ngIf="showToast" [message]="successMessage" (dismissCallback)="toggleToastBillRepost()">
</app-toast>